import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.slice";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsTopCategoriesBySpending(\n    $dateInTargetStartMonth: Date!\n    $dateInTargetEndMonth: Date!\n  ) {\n    financialTransactionsTopCategoriesBySpending(\n      dateInTargetStartMonth: $dateInTargetStartMonth\n      dateInTargetEndMonth: $dateInTargetEndMonth\n    ) {\n      topCategoriesBySpending {\n        amount\n        category\n      }\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsTopMerchantsBySpending(\n    $dateInTargetStartMonth: Date!\n    $dateInTargetEndMonth: Date!\n    $pagination: AdvancedOffsetPaginationInput\n  ) {\n    financialTransactionsTopMerchantsBySpending(\n      dateInTargetStartMonth: $dateInTargetStartMonth\n      dateInTargetEndMonth: $dateInTargetEndMonth\n      pagination: $pagination\n    ) {\n      topMerchantsBySpending {\n        amount\n        merchantName\n      }\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsAverageSpendingByDayOfTheMonth(\n    $dateInTargetStartMonth: Date!\n    $dateInTargetEndMonth: Date!\n  ) {\n    financialTransactionsAverageSpendingByDayOfTheMonth(\n      dateInTargetStartMonth: $dateInTargetStartMonth\n      dateInTargetEndMonth: $dateInTargetEndMonth\n    ) {\n      averageSpendingByDayOfTheMonth {\n        amount\n        dayOfTheMonth\n      }\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsSpendingByMonth(\n    $dateInTargetStartMonth: Date!\n    $dateInTargetEndMonth: Date!\n    $filter: FinancialTransactionsFilterInput\n  ) {\n    financialTransactionsSpendingByMonth(\n      dateInTargetStartMonth: $dateInTargetStartMonth\n      dateInTargetEndMonth: $dateInTargetEndMonth\n      filter: $filter\n    ) {\n      spendingByMonth {\n        amount\n        date\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsSpendingByDateForMonth($dateInTargetMonth: Date!) {\n    financialTransactionsSpendingByDateForMonth(dateInTargetMonth: $dateInTargetMonth) {\n      spendingByDayOfTheMonthForPriorMonth {\n        dayOfTheMonth\n        amount\n      }\n      spendingByDayOfTheMonthForTargetMonth {\n        dayOfTheMonth\n        amount\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsProjectionForMonth($dateInTargetMonth: Date!) {\n    financialTransactionsProjectionForMonth(dateInTargetMonth: $dateInTargetMonth) {\n      earning\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetFinancialTransactionsSpendingAndEarningForMonthRange(\n    $dateInStartMonth: Date!\n    $dateInEndMonth: Date!\n    $filter: FinancialTransactionsFilterInput\n  ) {\n    financialTransactionsSpendingAndEarningForMonthRange(\n      dateInStartMonth: $dateInStartMonth\n      dateInEndMonth: $dateInEndMonth\n      filter: $filter\n    ) {\n      spendingAndEarningForMonthRange {\n        spending\n        earning\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@nerdwallet/apollo';
export var FINANCIAL_TRANSACTIONS_SPENDING_AND_EARNING_FOR_MONTH_RANGE = gql(_templateObject());
export var FINANCIAL_TRANSACTIONS_PROJECTION_FOR_MONTH = gql(_templateObject2());
export var FINANCIAL_TRANSACTIONS_SPENDING_BY_DATE_FOR_MONTH = gql(_templateObject3());
export var FINANCIAL_TRANSACTIONS_SPENDING_BY_MONTH = gql(_templateObject4());
export var FINANCIAL_TRANSACTIONS_AVERAGE_SPENDING_BY_DAY_OF_THE_MONTH = gql(_templateObject5());
export var FINANCIAL_TRANSACTIONS_TOP_MERCHANT_SPENDING = gql(_templateObject6());
export var FINANCIAL_TRANSACTIONS_TOP_CATEGORIES_SPENDING = gql(_templateObject7());